import camelcaseKeys from 'camelcase-keys';

const contentLoader = {
  data () {
    return {
      document: null
    };
  },

  computed: {
    className () {
      return [this.$route.params.uid, this.$route.name, this.$route.meta.uid];
    },

    title () {
      return this.document.title;
    },

    slices () {
      return this.document.body;
    }
  },

  methods: {
    toSlice (slice) {
      return `${this.camelize(slice.slice_type)}Slice`;
    },

    camelize (str) {
      return str
        .split('_')
        .map((w) => w.replace(/./, (m) => m.toUpperCase()))
        .join('');
    },

    sliceToComponent (slice) {
      return this.camelize(slice.sliceType) + 'Slice';
    },

    loadByUID (params) {
      const contentParams = params || this.contentParams;

      if (contentParams) {
        this.getContentByUID(contentParams);
      }
    },

    getContentByUID (options) {
      let document;

      if (options.uid === '*') {
        document = window.prismicData.results.filter((document) => {
          const typeMatch = document.type === options.type;
          const locationMatch = !options.location || document.data.location === options.location;
          return typeMatch && locationMatch;
        });
      } else {
        document = window.prismicData.results.filter((document) => document.type === options.type && document.uid === options.uid);
      }

      if (document && document.length) {
        const target = options.target || 'document';
        this[target] = camelcaseKeys(document[0].data, { deep: true });
      } else if (this.$router.currentRoute.name !== 'not-found') {
        // this.$router.push({ name: 'not-found' });
      }
    }
  },

  created () {
    this.loadByUID();
  }
};

export default contentLoader;
